import { hubFeedback } from '~/lib/ticket-reader/hubScanner'

// A scan's result as a sound and a buzz: success, warning (someone at the door decides) or error.
// Sounds are made in the page (Web Audio), so they need a tap first: readySound() on "Start scanning".
// Johku Hub's app buzzes itself; elsewhere the browser does where it can (not Safari).

let audio = null

export function readySound () {
  try {
    const Context = window.AudioContext || window.webkitAudioContext
    if (!audio && Context) {
      audio = new Context()
    }
    if (audio && audio.state === 'suspended') {
      audio.resume()
    }
  } catch (e) {
    audio = null
  }
}

const TONES = {
  success: [[1320, 0, 0.11, 'sine']],
  warning: [[990, 0, 0.09, 'sine'], [990, 0.15, 0.09, 'sine']],
  error: [[330, 0, 0.16, 'square'], [220, 0.2, 0.26, 'square']]
}

const VIBRATIONS = {
  success: [45],
  warning: [45, 90, 45],
  error: [130, 80, 130, 80, 130]
}

function beep (kind) {
  if (!audio || !TONES[kind]) {
    return
  }
  const now = audio.currentTime
  TONES[kind].forEach(([frequency, start, length, wave]) => {
    const oscillator = audio.createOscillator()
    const gain = audio.createGain()
    oscillator.type = wave
    oscillator.frequency.value = frequency
    // Square waves are loud: quieter, and every tone fades in and out without a click
    const level = wave === 'square' ? 0.12 : 0.3
    gain.gain.setValueAtTime(0, now + start)
    gain.gain.linearRampToValueAtTime(level, now + start + 0.01)
    gain.gain.setValueAtTime(level, now + start + length - 0.03)
    gain.gain.linearRampToValueAtTime(0, now + start + length)
    oscillator.connect(gain).connect(audio.destination)
    oscillator.start(now + start)
    oscillator.stop(now + start + length + 0.02)
  })
}

export function vibrationAvailable () {
  return typeof window !== 'undefined' && (!!(window.JohkuHubScanner || (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.johkuHubScanner)) || typeof navigator.vibrate === 'function')
}

export function signal (kind, { sound, vibration }) {
  if (sound) {
    beep(kind)
  }
  if (vibration && !hubFeedback(kind) && typeof navigator.vibrate === 'function') {
    navigator.vibrate(VIBRATIONS[kind])
  }
}
